import { createAsyncThunk } from '@reduxjs/toolkit';
import { TrainingType } from './trainertypeType';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const createTrainingType = createAsyncThunk(
    'trainingtype/createTrainingtype',
    async (formData : TrainingType ,  {rejectWithValue}) =>{
        try {
           const response = await employeeServiceApiInstance.post('/trainingtype', formData);
          return response.data;
        } catch (error : any) {
            return rejectWithValue(error.response?.data || 'Failed to create training');
        }
    }
)

export const updatetrainingtype = createAsyncThunk(
    'trainingtype/updateTrainingtype',
    async ({ id, data }: { id: number; data: TrainingType }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/trainingtype/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update trainingtype');
        }
    }
);

export const fetchAlltrainingtype = createAsyncThunk(
    'trainingtype/fetchAlltrainingtype',
    async (_, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get('/trainingtype');
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch trainingtype Details');
      }
    }
  )

  export const deletetrainingtypeById = createAsyncThunk(
    'trainingtype/deletetraininglistById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.delete(`/trainingtype/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Delete');
      }
    }
  );


  export const gettrainingtypeById = createAsyncThunk(
    'trainingtype/gettrainingtypeById',
    async ({id} : {id : number}, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/trainingtype/${id}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to get');
      }
    }
  );
